import React from "react";
import {
  Alert,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { DEFAULT_LOW_STOCK_QUANTITY_THRESHOLD } from "../utils/medicineLowStock";
import {
  FORM_CANCEL_BUTTON_SX,
  FORM_SUBMIT_BUTTON_SX,
  STANDARD_FORM_DIALOG_ACTIONS_SX,
  STANDARD_FORM_DIALOG_PAPER_SX,
  STANDARD_FORM_DIALOG_TITLE_SX,
} from "../utils/formModalStyles";

const PharmacyLowStockAlertDialog = ({
  open,
  onClose,
  medicines = [],
  quantityThreshold = DEFAULT_LOW_STOCK_QUANTITY_THRESHOLD,
  onGoToInventory,
}) => {
  const outOfStockCount = medicines.filter((m) => m.totalQuantity === 0).length;
  const lowStockCount = medicines.length - outOfStockCount;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      sx={STANDARD_FORM_DIALOG_PAPER_SX}
    >
      <DialogTitle sx={STANDARD_FORM_DIALOG_TITLE_SX}>
        Low Stock Alert
      </DialogTitle>
      <DialogContent>
        {medicines.length === 0 ? (
          <Alert severity="success" sx={{ mb: 2 }}>
            No medicines are currently low or out of stock.
          </Alert>
        ) : (
        <Alert severity="warning" sx={{ mb: 2 }}>
          {medicines.length} medicine{medicines.length === 1 ? "" : "s"} need attention
          {outOfStockCount > 0 && lowStockCount > 0
            ? ` (${outOfStockCount} out of stock, ${lowStockCount} low stock)`
            : outOfStockCount > 0
              ? " (out of stock)"
              : ""}
          . Available quantity is at or below <strong>{quantityThreshold}</strong> units.
        </Alert>
        )}

        {medicines.length > 0 && (
        <TableContainer sx={{ maxHeight: 360 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Medicine Name</TableCell>
                <TableCell align="right">Available Qty</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {medicines.map((medicine, index) => (
                <TableRow key={`${medicine.medicineId ?? medicine.name}-${index}`} hover>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>
                    <Typography variant="body2" fontWeight={600}>
                      {medicine.name}
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography
                      variant="body2"
                      fontWeight={700}
                      color={medicine.totalQuantity === 0 ? "error.main" : "warning.main"}
                    >
                      {medicine.totalQuantity} units
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={medicine.status}
                      size="small"
                      color={medicine.totalQuantity === 0 ? "error" : "warning"}
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        )}
      </DialogContent>
      <DialogActions sx={STANDARD_FORM_DIALOG_ACTIONS_SX}>
        <Button onClick={onClose} variant="outlined" color="primary" sx={FORM_CANCEL_BUTTON_SX}>
          Dismiss
        </Button>
        {onGoToInventory && (
          <Button
            variant="contained"
            color="primary"
            onClick={onGoToInventory}
            sx={FORM_SUBMIT_BUTTON_SX}
          >
            Go to Inventory
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default PharmacyLowStockAlertDialog;
